/**
 * Converts speed from meters per second (m/s) to miles per hour (mph)
 * @param speedInMs Speed in meters per second
 * @returns Speed in miles per hour
 */
export const msToMph = (speedInMs: number | null): number => {
  if (speedInMs === null) return 0;
  return speedInMs * 2.237; // 1 m/s = 2.237 mph
};

/**
 * Converts speed from meters per second (m/s) to kilometers per hour (km/h)
 * @param speedInMs Speed in meters per second
 * @returns Speed in kilometers per hour
 */
export const msToKmh = (speedInMs: number | null): number => {
  if (speedInMs === null) return 0;
  return speedInMs * 3.6; // 1 m/s = 3.6 km/h
};

/**
 * Formats speed with the specified unit
 * @param speedInMs Speed in meters per second
 * @param unit Unit to convert to ('mph' or 'kmh')
 * @param decimals Number of decimal places
 * @returns Formatted speed string with unit
 */
export const formatSpeed = (
  speedInMs: number | null,
  unit: "mph" | "kmh" = "mph",
  decimals: number = 1
): string => {
  if (speedInMs === null) return "N/A";

  const speed = unit === "mph" ? msToMph(speedInMs) : msToKmh(speedInMs);
  return `${speed.toFixed(decimals)} ${unit}`;
};

/**
 * Formats raw speed value by adding MPH unit
 * @param speed Speed value in MPH
 * @param decimals Number of decimal places
 * @returns Formatted speed string with MPH unit
 */
export const formatRawSpeed = (
  speed: number | null,
  decimals: number = 0
): string => {
  if (speed === null) return "N/A";
  return `${speed.toFixed(decimals)} mph`;
};
